export const TEXTBOOK_WORDS_PER_PAGE = 20;
